import { COLORS } from './colors';

export const getTheme = () => {
  return {
    token: {
      colorPrimary: COLORS.primary,
      colorBgLayout: COLORS.whiteL0,
      fontSize: 16,
      fontFamily: 'LatoRegular',
      fontSizeHeading2: 30,
      fontSizeHeading4: 20,
    },
    components: {
      Button: {
        borderRadius: 8,
        colorTextDisabled: COLORS.whiteL0,
        colorBgContainerDisabled: COLORS.tundoraL2,
      },
      Alert: {
        colorErrorBg: COLORS.whiteL0,
        colorError: COLORS.error,
        colorErrorBorder: COLORS.error,
        colorText: COLORS.error,
      },
      Checkbox: {
        colorBgContainer: COLORS.whiteL0,
        colorText: COLORS.primary,
      },
    },
  };
};
